import React, { Component } from 'react';
import { withStyles, Input, Button } from '@material-ui/core';
import { Person, VpnKey, Keyboard } from '@mui/icons-material';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import common from '~/common';
import Actions from '~/Actions';

const styles = theme => ({
  row: { height: 47, display: 'flex', justifyContent: 'center', alignItems: 'center' },
  icon: { width: 20, height: 20, color: 'rgba(0, 0, 0, 0.54)', marginRight: 4 },
  input: { width: 328, fontSize: 20, paddingLeft: 8 },
});

class App extends Component {
  constructor (props) {
    super(props);
    this.state = {
      account: '',
      passwd: '',
      valid_code: '',
      error: [false, false, false, false],
      canSend: true,
      guideText: '',
    };
    this.focus = [false, false, false];
  }

  componentDidMount () {
    localStorage.removeItem('token');
    localStorage.removeItem('refresh_token');
    this.refresh();
    document.addEventListener('keydown', this.handleKeydown);
    this.actInputRef.focus();
    localStorage.removeItem('Wind_ID');
  }

  componentDidUpdate (preProp) {
    const { session: preSession = {} } = preProp;
    const { session = {}, history, isManage, clearSession } = this.props;
    const needChange = session?.data?.need_change_pad;
    
    if (session.status === '200' && needChange) {
      if (!this.timer) {
        this.second = 3;
        this.setState({ guideText: `超過三個月未修改密碼，將導向至修改密碼頁...${this.second}` });
        this.timer = setInterval(() => {
          this.second = this.second - 1;
          if (this.second > 0) {
            this.setState({ guideText: `超過三個月未修改密碼，將導向至修改密碼頁...${this.second}` });
          } else {
            clearInterval(this.timer);
            this.timer = null;
            const uuid = (session && session.data && session.data.change_passwd_uuid) || '';
            if (typeof clearSession === 'function') clearSession();
            history.push(`${common.rootPath}/Login/ChangePsd/${uuid}`);
          }
        }, 1000);
      }
    } else if (session.status === '200' && !needChange) {
      history.push(`${common.rootPath}${isManage ? '/Manage' : ''}/Login/Detail`);
    } else if (Object.keys(preSession).length === 0 && Object.keys(session).length > 0) {
      this.refresh();
      this.setState({ canSend: true, guideText: '' });
    }
  }

  componentWillUnmount () {
    this.props.clearKey('LoginCaptcha');
    document.removeEventListener('keydown', this.handleKeydown);
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  refresh =() => {
    this.props.clearKey('LoginCaptcha');
    this.props.getLoginCaptcha();
  }

  handleKeydown=event => {
    if (event.keyCode === 13) {
      switch (this.focus.indexOf(true)) {
      case -1: this.send(); break;
      case 0: this.psdInputRef.focus(); break;
      case 1: this.cthInputRef.focus(); break;
      case 2: this.cthInputRef.blur(); this.send(); break;
      default:break;
      }
    }
  }

  send=() => {
    const { loginCaptcha = {}, clearSession } = this.props;
    const { deadline, valid_id = '' } = loginCaptcha;
    const { account, passwd, valid_code } = this.state;
    const error = [
      account.length === 0,
      passwd.length === 0,
      valid_code.length === 0,
      false,
    ];

    clearSession();

    if (error.indexOf(true) === -1 && deadline && (new Date() > deadline)) { // 驗證碼過期
      error[3] = true;
    }
    if (error.indexOf(true) === -1) { // 欄位皆不為空且驗證碼有效
      this.setState({ canSend: false });
      this.props.postLogin({
        account,
        passwd,
        valid_code,
        valid_id,
      });
    }
    this.setState({ error });
  }

  foget=() => {
    const { isManage } = this.props;
    this.props.history.push(`${common.rootPath}${isManage ? '/Manage' : ''}/Login/FogetPsd`);
  }

  render () {
    const { classes, loginCaptcha = {}, session = {} } = this.props;
    const { image: CaptchaImage } = loginCaptcha;
    const { account, passwd, valid_code, error, canSend, guideText } = this.state;
    const { data: sessionData = {}, status: sessionStatus } = session || {};
    return (
      <div style={{ width: '100%', height: '100%', paddingTop: 46 }}>
        <form>
          <div className={classes.row}>
            <Person className={classes.icon} />
            <Input inputRef={ref => (this.actInputRef = ref)} className={classes.input} placeholder="帳號" inputProps={{ 'aria-label': 'description', maxLength: 100 }} value={account} onChange={e => this.setState({ account: e.target.value })} onBlur={() => (this.focus[0] = false)} onFocus={() => (this.focus[0] = true)} />
          </div>
          <div style={{ height: 16 }} />
          <div className={classes.row}>
            <VpnKey className={classes.icon} />
            <Input inputRef={ref => (this.psdInputRef = ref)} className={classes.input} autoComplete='off' placeholder="密碼" inputProps={{ 'aria-label': 'description', maxLength: 100 }} type="password" value={passwd} onChange={e => this.setState({ passwd: e.target.value })} onBlur={() => (this.focus[1] = false)} onFocus={() => (this.focus[1] = true)} />
          </div>
          <div style={{ height: 16 }} />
          <div className={classes.row} style={{ position: 'relative' }}>
            <Keyboard className={classes.icon} />
            <Input inputRef={ref => (this.cthInputRef = ref)} className={classes.input} placeholder="圖形驗證碼" inputProps={{ 'aria-label': 'description', maxLength: 6 }} value={valid_code} onChange={e => this.setState({ valid_code: e.target.value })} onBlur={() => (this.focus[2] = false)} onFocus={() => (this.focus[2] = true)} />
            <img style={{ position: 'absolute', width: 104, right: 61, cursor: 'pointer' }} src={CaptchaImage} onClick={this.refresh} alt='' />
          </div>
        </form>
        <div style={{ height: 12 }} />
        <div style={{ display: 'flex' }}>
          <div style={{ width: 242, display: 'flex', flexDirection: 'row', marginLeft: 62, color: 'red' }}>
            {error[0] && '[帳號]'}
            {error[1] && '[密碼]'}
            {error[2] && '[驗證碼]'}
            {(error[0] || error[1] || error[2]) && '不可為空'}
            {error[3] && '驗證碼已過期，請重新取得驗證碼'}
            {session.status && session.status !== '200' && session.status !== 40100 && session.status !== 40103 && session.status !== 40108 && session.status !== 40112 && session.status !== 40113 && (session.message || '登入失敗')}
            {session.status && session.status !== '200' && session.status === 40100 && '登入失敗'}
            {session.status && session.status !== '200' && (session.status === 40103 || session.status === 40108) && '帳號或密碼錯誤'}
            {session.status && session.status !== '200' && session.status === 40112 && '驗證碼錯誤'}
            {session.status && session.status !== '200' && session.status === 40113 && '驗證碼已過期，請重新取得驗證碼'}
            {sessionStatus === '200' && sessionData?.need_change_pad && guideText}
          </div>
          <div style={{ cursor: 'pointer', color: 'rgba(0, 0, 0, 0.54)', fontSize: 18, height: 24, textAlign: 'center' }} onClick={this.foget}>忘記密碼？</div>
        </div>
        <div style={{ height: 21 }} />
        <Button disabled={!canSend} style={{ width: 155, height: 47, borderRadius: 5, backgroundColor: canSend ? '#247690' : 'gray', color: 'white', fontSize: 20 }} onClick={this.send}>
          登入
        </Button>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  loginCaptcha: state.data.LoginCaptcha,
  session: state.session,
  isManage: state.isManage,
});
const mapDispatchToProps = dispatch => ({
  postLogin: body => Actions.postLogin(dispatch, body),
  getLoginCaptcha: () => Actions.getLoginCaptcha(dispatch),
  clearKey: key => Actions.clearKey(dispatch, { key }),
  clearSession: () => dispatch(Actions.clearSession()),
});
export default withStyles(styles)(withRouter(connect(mapStateToProps, mapDispatchToProps)(App)));
